import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Project Subtype',
    field: 'projectSubType',
    filter: 'text',
    searchable: true,
  },
];
